import React from "react";

import PageHelmet from "../component/common/Helmet";
import Breadcrumb from "../elements/common/Breadcrumb";
import TabOne from "../elements/tab/TabOne";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";
import { useTranslation } from "react-i18next";

const Team = () => {
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === "en";

  return (
    <>
    
      <Header
        headertransparent="header--transparent"
        colorblack="color--black"
        logoname="logo.png"
      />
     
      <Breadcrumb
        title={isEnglish ? "Education & Outreach" : "Éducation et diffusion"}
      />
      
      <main className="page-wrapper">
       
        <div className="about-area ptb--120  bg_color--1">
          <div className="about-wrapper">
            <div className="container">
              <div className="row row--35">
                <div className="col-lg-5">
                  <div className="thumbnail">
                    <img
                      className="w-100"
                      src="/assets/images/programs/image2.jpg"
                      alt="Programs Images"
                    />
                  </div>
                </div>
                <div className="col-lg-7">
                  <div className="about-inner inner">
                    <div className="section-title">
                      <span className="subtitle">
                        {isEnglish
                          ? "Education & Outreach"
                          : "Éducation et diffusion"}
                      </span>
                      <h2 className="title">
                        {isEnglish
                          ? "Education & Outreach"
                          : "Éducation et diffusion"}
                      </h2>
                      <p className="description">
                        CUS and all UM6P departments and schools believe in
                        learning by doing and flipped class methodologies. These
                        methodologies help students to gain knowledge by solving
                        real-life problems. In this context, CUS contributes to
                        providing high-quality education and programs of UM6P
                        (Masters, Bachelors, Internships, MOOCs, etc).
                      </p>
                    </div>
                 
                  </div>
                </div>
                <div className="col-lg-12 mt--80">
                  <TabOne tabStyle="tab-style--1" />
                </div>
              </div>
            </div>
          </div>
        </div>
       
      </main>
     
      <div className="backto-top">
        <ScrollToTop showUnder={160}>
          <FiChevronUp />
        </ScrollToTop>
      </div>
    
      <Footer />
    </>
  );
};

export default Team;
